import React, { useEffect, useState, useCallback } from "react";
import { Typography, Tooltip, Popover } from "antd";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { useIntl } from "react-intl";

import UserMenu from "./userMenu";
import { isSuperUser } from "../../../modules/session";
import { useUser } from "../../../modules/redux/session/useAuth";
import { setClient } from "../../../modules/redux/client/actions";

import "./index.css";

const { Text } = Typography;

const UserInfo = ({ setClient, savedClient, authenticated }) => {
  const intl = useIntl();
  const user = useUser();
  const [clientName, setClientName] = useState();
  const [clientTooltip, setClientTooltip] = useState();

  const setVisualClient = useCallback(
    (client) => {
      setClient(client);
      setClientName(client.name);
      setClientTooltip(
        intl.formatMessage({
          id: "user.company",
          defaultMessage: "Vaše společnost",
        }),
      );
    },
    [intl, setClient],
  );

  const handleClientChange = useCallback(
    (client) => {
      localStorage.setItem(`${user.id}_client`, JSON.stringify(client));
      setVisualClient(client);
      window.location.reload();
    },
    [user, setVisualClient],
  );

  const handleClientIdChange = useCallback(
    (clientId) => {
      handleClientChange(user.clients.find((c) => c.id === clientId));
    },
    [user, handleClientChange],
  );

  useEffect(() => {
    if (user) {
      if (user && user.clients && user.clients.length > 0) {
        if (user.clients.length > 1 || isSuperUser(user.role)) {
          const storedClient = localStorage.getItem(`${user.id}_client`);
          setVisualClient(
            storedClient ? JSON.parse(storedClient) : user.clients[0],
          );
        } else {
          setVisualClient(user.clients[0]);
        }
      } else {
        setClientName("--");
        setClientTooltip(
          intl.formatMessage({
            id: "user.noClients",
            defaultMessage: "uživatel nemá přiřazeného klienta",
          }),
        );
      }
    }
  }, [intl, user, authenticated, setVisualClient]);

  return authenticated && user ? (
    <Popover
      trigger="click"
      placement="bottomRight"
      title={intl.formatMessage({
        id: "user.menu",
        defaultMessage: "Uživatelské menu",
      })}
      content={
        <UserMenu
          userRole={user.role}
          clients={user.clients}
          onClientChange={handleClientChange}
          onClientIdChange={handleClientIdChange}
          defaultClientId={savedClient && savedClient.id}
        />
      }
    >
      <div className="user-info">
        <Text strong className="pointer">
          {user.firstname && user.lastname
            ? `${user.firstname} ${user.lastname}`
            : user.email}
        </Text>
        <Tooltip title={clientTooltip} className="pointer">
          <Text>{clientName}</Text>
        </Tooltip>
      </div>
    </Popover>
  ) : null;
};

const mapStateToProps = ({ client, session }) => ({
  authenticated: session.authenticated,
  savedClient: client.data,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setClient,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(UserInfo);
